import Employee, {
  EmployeeConstructorArguments,
} from "../../../../../app/domain/Employee";

export class EmployeeNotRemoved extends Employee {
  warning: string;

  error: string;

  modelId: string;

  benefitPlanName: string;

  constructor({
    warning,
    error,
    modelId,
    benefitPlanName,
    ...employeeArguments
  }: EmployeeConstructorArguments & {
    warning?: string;
    error?: string;
    modelId?: string;
    benefitPlanName?: string;
  }) {
    super(employeeArguments);
    this.warning = warning || "";
    this.error = error || "";
    this.modelId = modelId || "";
    this.benefitPlanName = benefitPlanName || "";
  }
}

interface EmployeesContextInterface {
  employees?: Employee[];
  setEmployees(e: any): void;
  loadEmployees(): void;
  isLoading: boolean;
  setIsLoading(e: any): void;
  employeesNotRemoved: EmployeeNotRemoved[];
}

export default EmployeesContextInterface;
